module.exports = __webpack_public_path__ + "assets/img/collection_0.55dcc4fa.svg";